import styled from 'styled-components';
import CHECK_ICON from '@/assets/refund/check_circle.png';

type FXReceiptCancelCompleteModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

function FXReceiptCancelCompleteModal({
  isOpen,
  onClose,
}: FXReceiptCancelCompleteModalProps) {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <IconWrapper>
          <CheckIcon src={CHECK_ICON} alt='완료' />
        </IconWrapper>

        <Title>현금 영수증 발행이 취소되었습니다</Title>

        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </ModalContent>
    </ModalOverlay>
  );
}

export default FXReceiptCancelCompleteModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  padding: 64px 32px 32px 32px;
  width: 672px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;

const CheckIcon = styled.img`
  width: 100%;
  height: 100%;
`;

const Title = styled.h2`
  color: var(--Mono-80, #3a3b3e);
  text-align: center;
  font-family: Pretendard, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.48px;
  margin-bottom: 56px;
`;

const ConfirmButton = styled.button`
  width: 100%;
  height: 52px;
  border-radius: 8px;
  border: none;
  background: #246cf6;
  color: #fff;
  text-align: center;
  font-family: Pretendard, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;
